import { countries, Countries } from "@/lib/ms-dynamics-365/countries";
import { InputWrapper } from "@/lib/styles";
import { useRouter } from "next/router";
import React, { useMemo } from "react";
import Select from "react-select";
import SelectDropdown from "./SelectDropdown";

const InputCountry: React.FC<any> = (props) => {
  const { locale, defaultLocale } = useRouter();

  const options = useMemo(
    () =>
      Object.entries(countries).map((entry) => {
        const [key, value] = entry;

        let label: string | undefined;
        if (locale) label = value[locale];
        if (!label && defaultLocale) label = value[defaultLocale];
        if (!label) label = key;

        return {
          value: key,
          label,
        };
      }),
    [locale, defaultLocale]
  );

  return <SelectDropdown {...props} items={options} />;
};

export default InputCountry;
